import { render } from "./models.vue?vue&type=template&id=448720dc&scoped=true"
import script from "./models.vue?vue&type=script&lang=js"
export * from "./models.vue?vue&type=script&lang=js"

import "./models.vue?vue&type=style&index=0&id=448720dc&scoped=true&lang=css"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-448720dc"]])

export default __exports__